<div class="basin-pb-2 basin-width-100">
    <div class="basin-pb-2">
        <p>You have uploaded a shapefile that will be processed in batch mode, allowing multiple scenarios to run simultaneously.</p>
        <p>Visualization is not available in this mode.</p>
        <p>To enable visualization, please delete the current shapefile and upload a different one.</p>
    </div>
</div>

<div class="p-d-flex p-flex-row p-jc-end">
    <button style="display:none;" pButton (click)="onAccept(Decision.Back)" label="Go Back" class="p-button-text basin-mr-6"></button>
    <button pButton (click)="onAccept(Decision.Continue)" class="p-button-text submit-button" label="Continue"></button>
</div>
